'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _UIAbstractPopup = require('./UIAbstractPopup');

var _UIAbstractPopup2 = _interopRequireDefault(_UIAbstractPopup);

var _UIPopoverContent = require('./UIPopoverContent');

var _UIPopoverContent2 = _interopRequireDefault(_UIPopoverContent);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _times = require('HubStyleTokens/times');

var _Functions = require('../core/Functions');

var _EventHandlers = require('../core/EventHandlers');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Placement = require('./utils/Placement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var POPOVER_TRANSITION_TIMEOUT = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);

var getArrowSize = function getArrowSize(arrowSize, use) {
  if (arrowSize != null) return arrowSize;
  if (use === 'tooltip' || use === 'tooltip-danger') return 'small';
  return 'medium';
};

var getPlacement = function getPlacement(placementProp, placementState) {
  return placementState || placementProp;
};

var UIPopover = _react2.default.createClass({
  displayName: 'UIPopover',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, _UIPopoverContent2.default.propTypes, {
    addTargetClasses: _react.PropTypes.bool,
    arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)),
    autoPlacement: _UIAbstractPopup2.default.propTypes.autoPlacement,
    children: _react.PropTypes.element,
    closeOnOutsideClick: _react.PropTypes.bool.isRequired,
    content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
      header: _react.PropTypes.node,
      body: _react.PropTypes.node,
      footer: _react.PropTypes.node
    })]).isRequired,
    onFocusLeave: _react.PropTypes.func,
    onChangePlacement: _react.PropTypes.func,
    onCloseComplete: _react.PropTypes.func,
    onCloseStart: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onOpenStart: _react.PropTypes.func,
    pinToConstraint: _UIAbstractPopup2.default.propTypes.pinToConstraint,
    pinToOutOfBoundsTarget: _UIAbstractPopup2.default.propTypes.pinToOutOfBoundsTarget,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    target: _react.PropTypes.instanceOf(HTMLElement),
    targetAttachment: _react.PropTypes.string.isRequired,
    _distanceAdjustment: _react.PropTypes.number,
    _insetAdjustment: _react.PropTypes.number,
    _bodyElement: _react.PropTypes.instanceOf(HTMLElement),
    _useMutationObserver: _react.PropTypes.bool.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIPopoverContent2.default.defaultProps, {
      autoPlacement: true,
      closeOnOutsideClick: true,
      _distanceAdjustment: 0,
      _insetAdjustment: 0,
      open: false,
      pinToConstraint: ['top', 'bottom'],
      pinToOutOfBoundsTarget: false,
      placement: 'top',
      targetAttachment: 'auto',
      _useMutationObserver: false
    });
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        animateOnMount = _props.animateOnMount,
        open = _props.open;

    return {
      hasRendered: false,
      isVisible: false,
      openComplete: open && !animateOnMount,
      placement: null
    };
  },
  componentWillMount: function componentWillMount() {
    var _props2 = this.props,
        content = _props2.content,
        open = _props2.open;

    if (content && open) {
      // If we're initially open, we want to set `isVisible: true` before first
      // render. Otherwise, calling updateIsVisible is undesirable.
      this.updateIsVisible(this.props, true);
    }
  },
  componentDidMount: function componentDidMount() {
    this._isMounted = true;
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({
      hasRendered: true
    });
    /* eslint-enable react/no-did-mount-set-state */

    // Depending on our props, we may or may not start listening for outside clicks
    this.toggleOutsideClickListener(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If the placement prop is reset, clear our internal override.
    if (nextProps.placement !== this.props.placement) {
      this.setState({
        placement: null
      });
    }

    if (nextProps.open !== this.props.open || !!nextProps.content !== !!this.props.content) {
      this.updateIsVisible(nextProps, false);
    }

    // Depending on our new props, we may either start or stop listening for outside clicks
    this.toggleOutsideClickListener(nextProps);
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
    this.unlistenForOutsideClick();
    clearTimeout(this._leaveTransitionTimeout);
  },
  toggleOutsideClickListener: function toggleOutsideClickListener(props) {
    var closeOnOutsideClick = props.closeOnOutsideClick,
        open = props.open;

    if (closeOnOutsideClick && open) {
      this.listenForOutsideClick();
    } else {
      this.unlistenForOutsideClick();
    }
  },
  listenForOutsideClick: function listenForOutsideClick() {
    window.addEventListener('click', this.handleWindowClick);
  },
  unlistenForOutsideClick: function unlistenForOutsideClick() {
    window.removeEventListener('click', this.handleWindowClick);
  },
  handleWindowClick: function handleWindowClick(evt) {
    var _props3 = this.props,
        onOpenChange = _props3.onOpenChange,
        open = _props3.open,
        target = _props3.target;

    if (!open) {
      return;
    }

    if (!this._isMounted) {
      return;
    }
    var clickTarget = evt.target;
    var tetherTarget = (0, _reactDom.findDOMNode)(target || this);
    var contentEl = (0, _reactDom.findDOMNode)(this._content);

    // Ignore the click if it's within our Tether target
    if (tetherTarget && tetherTarget.contains(clickTarget)) {
      return;
    }

    // Ignore the click if it's within our popover container
    if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) {
      return;
    }

    // Otherwise, trigger close
    onOpenChange((0, _SyntheticEvent2.default)(false));
  },
  updateIsVisible: function updateIsVisible(props, isMountRender) {
    // Determine whether our UIAbstractPopup should be open or closed. We must
    // wait for our leave transition to complete before closing it.
    var animateOnMount = props.animateOnMount,
        animateOnToggle = props.animateOnToggle,
        content = props.content,
        onCloseStart = props.onCloseStart,
        onOpenStart = props.onOpenStart,
        open = props.open;


    var hasAnimation = isMountRender && animateOnMount || !isMountRender && animateOnToggle;
    var animationTransitionTimeout = hasAnimation ? POPOVER_TRANSITION_TIMEOUT : 0;

    if (content && open) {
      (0, _Functions.callIfPossible)(onOpenStart);
      this.setState({
        isVisible: true,
        placement: null
      });
      clearTimeout(this._leaveTransitionTimeout);
      this._leaveTransitionTimeout = null;
      setTimeout(this.onEnterComplete, animationTransitionTimeout);
    } else if (!this._leaveTransitionTimeout) {
      this.setState({ openComplete: false });
      (0, _Functions.callIfPossible)(onCloseStart);
      this._leaveTransitionTimeout = setTimeout(this.onLeaveComplete, animationTransitionTimeout);
    }
  },
  onEnterComplete: function onEnterComplete() {
    var onOpenComplete = this.props.onOpenComplete;

    if (this._isMounted) {
      this.setState({ openComplete: true });
    }
    (0, _Functions.callIfPossible)(onOpenComplete);
  },
  onLeaveComplete: function onLeaveComplete() {
    var onCloseComplete = this.props.onCloseComplete;

    (0, _Functions.callIfPossible)(onCloseComplete);
    if (this._isMounted) {
      this.setState({
        isVisible: false
      });
    }
    this._leaveTransitionTimeout = null;
  },
  handleTetherUpdate: function handleTetherUpdate(event) {
    // Adjust our placement state to reflect Tether's response to a constraint
    var _props4 = this.props,
        autoPlacement = _props4.autoPlacement,
        onChangePlacement = _props4.onChangePlacement,
        placementProp = _props4.placement;
    var placementState = this.state.placement;

    var oldPlacement = getPlacement(placementProp, placementState);

    var newPlacementVert = autoPlacement === 'horiz' ? (0, _Placement.getVertPart)(oldPlacement) : event.targetAttachment.top;
    var newPlacementHoriz = autoPlacement === 'vert' ? (0, _Placement.getHorizPart)(oldPlacement) : event.targetAttachment.left;

    if (!newPlacementVert || !newPlacementHoriz) {
      // This indicates pinning, which we don't need to respond to
      return;
    }

    var newPlacement = null;
    if (newPlacementVert === 'center' || newPlacementVert === 'middle') {
      newPlacement = newPlacementHoriz;
    } else if (newPlacementHoriz === 'center' || newPlacementHoriz === 'middle') {
      // #1942
      newPlacement = newPlacementVert;
    } else {
      newPlacement = newPlacementVert + ' ' + newPlacementHoriz;
    }

    if (this.state.placement !== newPlacement) {
      this.setState({
        placement: newPlacement
      });
      (0, _Functions.callIfPossible)(onChangePlacement, { newPlacement: newPlacement });
    }
  },
  reposition: function reposition() {
    if (this._popup) {
      this._popup.repositionTether();
    }
  },
  contentRefCallback: function contentRefCallback(ref) {
    this._content = ref;
  },
  popupRefCallback: function popupRefCallback(ref) {
    this._popup = ref;
  },
  render: function render() {
    var _props5 = this.props,
        addTargetClasses = _props5.addTargetClasses,
        animateOnMount = _props5.animateOnMount,
        animateOnToggle = _props5.animateOnToggle,
        arrowColor = _props5.arrowColor,
        arrowSize = _props5.arrowSize,
        autoPlacement = _props5.autoPlacement,
        children = _props5.children,
        className = _props5.className,
        __closeOnOutsideClick = _props5.closeOnOutsideClick,
        content = _props5.content,
        id = _props5.id,
        onFocusLeave = _props5.onFocusLeave,
        __onChangePlacement = _props5.onChangePlacement,
        __onOpenChange = _props5.onOpenChange,
        __onOpenComplete = _props5.onOpenComplete,
        open = _props5.open,
        pinToConstraint = _props5.pinToConstraint,
        pinToOutOfBoundsTarget = _props5.pinToOutOfBoundsTarget,
        placementProp = _props5.placement,
        style = _props5.style,
        target = _props5.target,
        targetAttachment = _props5.targetAttachment,
        use = _props5.use,
        width = _props5.width,
        _bodyElement = _props5._bodyElement,
        _distanceAdjustment = _props5._distanceAdjustment,
        _insetAdjustment = _props5._insetAdjustment,
        _useMutationObserver = _props5._useMutationObserver,
        rest = _objectWithoutProperties(_props5, ['addTargetClasses', 'animateOnMount', 'animateOnToggle', 'arrowColor', 'arrowSize', 'autoPlacement', 'children', 'className', 'closeOnOutsideClick', 'content', 'id', 'onFocusLeave', 'onChangePlacement', 'onOpenChange', 'onOpenComplete', 'open', 'pinToConstraint', 'pinToOutOfBoundsTarget', 'placement', 'style', 'target', 'targetAttachment', 'use', 'width', '_bodyElement', '_distanceAdjustment', '_insetAdjustment', '_useMutationObserver']);

    var _state = this.state,
        hasRendered = _state.hasRendered,
        isVisible = _state.isVisible,
        openComplete = _state.openComplete,
        placementState = _state.placement;


    var computedArrowSize = getArrowSize(arrowSize, use);
    var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[computedArrowSize];
    var computedPlacement = getPlacement(placementProp, placementState);

    var renderedContent = _react2.default.createElement(_UIPopoverContent2.default, _extends({}, rest, {
      animateOnMount: animateOnMount,
      animateOnToggle: animateOnToggle,
      hasRendered: hasRendered,
      arrowColor: arrowColor,
      arrowSize: computedArrowSize,
      className: className,
      content: content,
      'data-component-name': 'UIPopover',
      'data-open-complete': openComplete,
      id: id,
      open: open,
      placement: computedPlacement,
      ref: this.contentRefCallback,
      style: style,
      use: use,
      width: width
    }));

    return _react2.default.createElement(
      _UIAbstractPopup2.default,
      {
        addTargetClasses: addTargetClasses,
        autoPlacement: autoPlacement,
        bodyElement: _bodyElement,
        center: computedArrowSize !== 'none',
        content: renderedContent,
        distance: computedArrowParams.distance + _distanceAdjustment,
        inset: computedArrowParams.inset + _insetAdjustment,
        onFocusLeave: onFocusLeave,
        onTetherUpdate: this.handleTetherUpdate,
        open: isVisible,
        pinToConstraint: pinToConstraint,
        pinToOutOfBoundsTarget: pinToOutOfBoundsTarget,
        placement: computedPlacement,
        ref: this.popupRefCallback,
        target: target,
        targetAttachment: targetAttachment,
        _useMutationObserver: _useMutationObserver
      },
      children
    );
  }
});

exports.default = (0, _Controllable2.default)(UIPopover, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/tooltip/UIPopover.js
// module id = 57
// module chunks = 0